@if (toastState) {
  <div class="toaster" [@toastState]>
    <div class="flex-box">
      <i class="fa fa-check-circle-o"></i>
      <p class="toaster-text" id="toaster-text">{{ content }}</p>
    </div>
  </div>
}
